<template>
  <UPopover mode="hover">
    <UButton color="neutral" variant="soft" icon="material-symbols:account-circle-outline"
      class="cursor-pointer rounded-full text-xl" size="xl" aria-label="Profile" rounded
      @click="handleProfileButtonClick" />

    <template #content>
      <section class="p-3 md:p-6 flex flex-col max-w-lg gap-3">

        <template v-if="isLoggedIn">
          <p>Hello {{ user?.name }}</p>
          <UButton v-if="isAdmin" color="primary" class="justify-start cursor-pointer" to="/admin/dashboard"
            icon="mdi:view-dashboard-edit" label="Admin Dashboard" />
          <UButton color="primary" class="justify-start cursor-pointer" to="/dashboard" icon="mdi:view-dashboard"
            label="My Dashboard" />
          <UButton color="primary" class="justify-start cursor-pointer" @click="logout" icon="mdi:logout"
            label="Logout">
          </UButton>
        </template>
        <template v-else>
          <UButton color="primary" class="justify-start cursor-pointer" @click="goToLogin" icon="mdi:login"
            label="Login" />
          <UButton color="primary" class="justify-start cursor-pointer" @click="goToRegister" icon="mdi:account-plus"
            label="Register" />
        </template>
      </section>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
const { logout, goToLogin, goToRegister, user, isLoggedIn, isAdmin } = useUser()

function handleProfileButtonClick() {
  if (!isLoggedIn.value) {
    goToLogin()
  }
}

</script>

<style scoped></style>
